const rnds8 = new Uint8Array(16);

function rng() {
	crypto.getRandomValues(rnds8);
	return rnds8;
}

const byteToHex: string[] = [];
for (let i = 0; i < 256; ++i) {
	byteToHex[i] = (i + 0x1_00).toString(16).slice(1);
}

function bytesToUuid(buf: Uint8Array) {
	return [
		byteToHex[buf[0]],
		byteToHex[buf[1]],
		byteToHex[buf[2]],
		byteToHex[buf[3]],
		'-',
		byteToHex[buf[4]],
		byteToHex[buf[5]],
		'-',
		byteToHex[buf[6]],
		byteToHex[buf[7]],
		'-',
		byteToHex[buf[8]],
		byteToHex[buf[9]],
		'-',
		byteToHex[buf[10]],
		byteToHex[buf[11]],
		byteToHex[buf[12]],
		byteToHex[buf[13]],
		byteToHex[buf[14]],
		byteToHex[buf[15]]
	].join('');
}

export function uuidv4() {
	const rnds = rng();

	// eslint-disable-next-line no-bitwise
	rnds[6] = (rnds[6] & 0x0F) | 0x40;
	// eslint-disable-next-line no-bitwise
	rnds[8] = (rnds[8] & 0x3F) | 0x80;

	return bytesToUuid(rnds);
}
